import { useTheme } from '@emotion/react';
import { ReactElement } from 'react';

import { Theme } from '../../../../../theme/interface/detailed';

export const SmileIcon = ({
	className,
	onClick,
	active,
}: {
	active: boolean;
	className: string;
	onClick: VoidFunction;
}): ReactElement => {
	const {
		chat: {
			icons: {
				smileIcon: { size, panelClosedColor, panelActiveColor },
			},
		},
	} = useTheme() as Theme;

	return (
		<svg
			onClick={onClick}
			onMouseDown={(e): void => e.preventDefault()}
			className={className}
			enableBackground="new 0 0 330 330"
			version="1.1"
			fill={active ? panelActiveColor : panelClosedColor}
			viewBox="0 0 330 330"
			width={size}
			height={size}
			xmlSpace="preserve"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M165,0C74.019,0,0,74.019,0,165s74.019,165,165,165s165-74.019,165-165S255.981,0,165,0z M165,300   c-74.439,0-135-60.561-135-135S90.561,30,165,30s135,60.561,135,135S239.439,300,165,300z" />
			<path d="m205.31 205.3c-22.226 22.224-58.386 22.225-80.611 1e-3 -5.857-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213c16.963 16.963 39.236 25.441 61.519 25.441 22.276 0 44.56-8.482 61.519-25.441 5.858-5.857 5.858-15.355 0-21.213-5.859-5.859-15.357-5.858-21.214-1e-3z" />
			<path d="m115.14 147.14c3.73-3.72 5.86-8.88 5.86-14.14s-2.13-10.42-5.86-14.14c-3.72-3.72-8.88-5.86-14.14-5.86-5.271 0-10.42 2.14-14.141 5.86-3.729 3.72-5.859 8.88-5.859 14.14s2.13 10.42 5.859 14.14c3.721 3.73 8.881 5.86 14.141 5.86s10.42-2.13 14.14-5.86z" />
			<path d="m229 113c-5.26 0-10.42 2.14-14.141 5.86-3.719 3.72-5.859 8.87-5.859 14.14s2.14 10.42 5.859 14.14c3.721 3.73 8.881 5.86 14.141 5.86s10.42-2.13 14.14-5.86c3.72-3.72 5.86-8.87 5.86-14.14 0-5.26-2.141-10.42-5.86-14.14-3.72-3.72-8.88-5.86-14.14-5.86z" />
		</svg>
	);
};
